<div class="bcg p-4">
  <div class="d-flex justify-content-between custom-container">
    <nav class="custom-nav">
      <ol class="breadcrumb">
        <li
          *ngIf="userRole === 'CLIENT'; else showAdminDashboard"
          class="breadcrumb-item"
          style="cursor: pointer"
          [routerLink]="'/doqfy/dashboard'"
        >
          Dashboard
        </li>
        <ng-template #showAdminDashboard>
          <li
            class="breadcrumb-item"
            style="cursor: pointer"
            [routerLink]="'/doqfy/admin-dashboard'"
          >
            Dashboard
          </li>
        </ng-template>
        <li
          class="breadcrumb-item active"
          style="cursor: context-menu"
          aria-current="page"
        >
          User Management
        </li>
      </ol>
    </nav>
  </div>

  <div class="card card_outLine mt-3">
    <div class="card-body">
      <div class="row align-items-center">
        <div class="col-lg-6 col-sm-6 col-md-6">
          <h5 class="title_five">User Management</h5>
          <p class="card-text text_p">
            Add new users and manage your existing users here!
          </p>
        </div>
        <div class="col-lg-6 col-sm-6 col-md-6 text-right custom_button">
          <p-button
            label="Add new User"
            icon="pi pi-plus-circle"
            [routerLink]="['/doqfy//management/user-create']"
            styleClass="p-button-sm-outline"
          ></p-button>
          <p-button
            label="Back"
            (click)="back()"
            styleClass="p-button-sm mx-2"
          ></p-button>
        </div>
      </div>
    </div>
  </div>
  <div class="card card_outLine mt-3">
    <div class="card-body">
      <div class="row mx-1">
        <div class="col-lg-5 col-sm-5 col-md-5">
          <h5 class="title_five">User Details</h5>
        </div>

        <div class="d-flex col-lg-7 col-sm-7 col-md-7 user-filters">
          <div class="custom_button">
            <app-column-chooser [table]="dataTable"></app-column-chooser>
          </div>

          <div class="custom_button">
            <p-button
              label="Export"
              icon="bx bx-export"
              (click)="export()"
              styleClass="p-button-sm-outline"
            ></p-button>
          </div>

          <div class="custom_button">
            <p-button
              label="Sample Template"
              (click)="template()"
              icon="bx bx-download"
              styleClass="p-button-sm-outline"
            ></p-button>
          </div>
          <div class="custom_button">
            <input
              [hidden]="true"
              type="file"
              id="upload_file"
              (change)="onFileChange($event)"
              accept=".xlsx"
              #fileInput
            />
            <p-button
              label="Bulk Upload"
              type="button"
              icon="bx bx-export"
              (click)="fileInput.click()"
              styleClass="p-button-sm-outline"
            ></p-button>
          </div>

          <div class="form_inputFields_mangment">
            <app-search-input
              [(ngModel)]="searchText"
              (ngModelChange)="onChangeSearchText($event)"
              placeholder="Search by Name">
            </app-search-input>
          </div>
        </div>
      </div>
      <div class="row m-2 mt-3">
        <app-data-table
          #dataTable
          [columnChooser]="true"
          [columns]="columns"
          [data]="userData"
          [totalRecords]="totalRecords"
          [rows]="rowsPerPage"
          [paginator]="true"
          [lazy]="true"
          [analyticsTab]="'User Listing'"
          emptyMessage="No Records Found"
          (pageChange)="onPageChange($event)"
          (rowClick)="editUser($event)">
          <ng-template appTableCell="s_no" let-row let-i="index">
            {{ pageCount + i + 1 }}
          </ng-template>

          <ng-template appTableCell="roles" let-row>
            <span
              *ngFor="let role of row.roles"
              class="badge background_color_1 status_title"
              style="color: #151515; margin-right: 5px"
              >{{ role }}</span
            >
          </ng-template>

          <ng-template appTableCell="is_active" let-row>
            <label
              class="toggle-switch"
              style="zoom: 80%"
              appRowActionStop
              (click)="notifyIfStatusLocked(row)"
            >
              <input
                type="checkbox"
                [ngModel]="!row.is_active" (ngModelChange)="row.is_active = $event"
                (click)="toggleUserStatus(row)"
                [disabled]="!canChangeStatus(row)"
              />
              <span class="slider"></span>
              <span class="switch-text">{{
                row.is_active ? "Active" : "Inactive"
              }}</span>
            </label>
          </ng-template>

          <ng-template appTableCell="is_approver" let-row>
            <label class="toggle-switch" style="zoom: 80%" appRowActionStop>
              <input
                type="checkbox"
                [ngModel]="!row.is_approver" (ngModelChange)="row.is_approver = $event"
                (click)="toggleApprover(row)"
                [disabled]="!canToggleStatus(row.roles)"
              />
              <span class="slider"></span>
              <span class="switch-text">{{
                row.is_approver ? "Yes" : "No"
              }}</span>
            </label>
          </ng-template>

          <ng-template appTableCell="action" let-row>
            <div class="clickable" appRowActionStop appIconAction (click)="editUser(row)">
              <i class="bx bx-edit"></i>
            </div>
          </ng-template>
        </app-data-table>
      </div>
    </div>
  </div>
</div>

<div class="toast_display_layer">
  <p-toast></p-toast>
</div>

<!-- Modal -->
<div
  class="modal fade"
  id="exampleModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <span class="d-flex justify-content-center title_five mt-5">
          Are you sure you want to delete?</span
        >
      </div>
      <div class="d-flex justify-content-center mb-5">
        <div class="custom_button_1 me-2">
          <p-button
            label="Confirm"
            (click)="showSuccess()"
            data-bs-dismiss="modal"
            styleClass="p-button-sm"
          ></p-button>
        </div>
        <div class="me-4 custom_button">
          <p-button
            label="Cancel"
            data-bs-dismiss="modal"
            styleClass="p-button-sm-outline"
          ></p-button>
        </div>
      </div>
    </div>
  </div>
</div>